import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import HeroSection from "../components/Home/HeroSection";
import CoreModules from "../components/Home/CoreModules";
import Benefitssection from "../components/Benefitssection";
import Modulessection from "../components/Modulessection";
import Testimonialssection from "../components/Testimonialssection";
import Pricingsection from "../components/Pricingsection";
import Faqsection from "../components/Faqsection";
import CtaBanner from "../components/Ctabanner"; // Importamos el componente CtaBanner

// Ya no importamos Terminos ni Privacidad aquí, porque ahora son páginas independientes.

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>
          FactuSysDR - Plataforma Empresarial para Facturación, Inventario y
          Ventas
        </title>
        <meta
          name="description"
          content="FactuSysDR: solución integral para facturación electrónica, gestión de inventario y control de ventas. Plataforma empresarial moderna y confiable."
        />
        <meta
          name="keywords"
          content="facturación, factura electrónica, inventario, ventas, software empresarial"
        />
        <meta
          property="og:title"
          content="FactuSysDR - Plataforma Empresarial para Facturación, Inventario y Ventas"
        />
        <meta
          property="og:description"
          content="FactuSysDR: solución integral para facturación electrónica, gestión de inventario y control de ventas."
        />
        <meta property="og:type" content="website" />
      </Helmet>

      <main>
        {/* Sección Hero - Introducción */}
        <HeroSection />

        {/* Beneficios */}
        <section id="beneficios">
          <Benefitssection />
        </section>

        {/* Módulos y funcionalidades (Core) */}
        <section id="modulos">
          <CoreModules />
        </section>

        {/* Más Módulos y funcionalidades */}
        <section id="modulos-extra">
          <Modulessection />
        </section>

        {/* Testimonios de clientes */}
        <section id="testimonios">
          <Testimonialssection />
        </section>

        {/* Planes de precios */}
        <section id="precios">
          <Pricingsection />
        </section>

        {/* Preguntas frecuentes */}
        <section id="faq">
          <Faqsection />
        </section>

        {/* Banner de llamada a la acción */}
        <section id="cta">
          <CtaBanner />
        </section>
      </main>
    </>
  );
};

export default HomePage;
